import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { PlanTier } from '../../graphql/generated/graphqlTypes';
import AuditLogContentView from './AuditLogContentView';
import AuditUpSellView from './AuditUpSellView';

const AuditView = () => {
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );
  const isFeatureEnabled =
    planTier === PlanTier.Business || planTier === PlanTier.Enterprise;

  return isFeatureEnabled ? <AuditLogContentView /> : <AuditUpSellView />;
};

export default AuditView;
